import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-xl-10 mb-5" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_7 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-300px" }, "Actor"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Permission"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Status")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder" }, "Account:", -1)
const _hoisted_10 = {
  key: 0,
  class: "badge badge-light-success fw-bold px-5 py-3 ms-4"
}
const _hoisted_11 = { class: "fs-7 badge badge-light-info border-dashed border-1 border-info m-1" }
const _hoisted_12 = {
  key: 0,
  class: "fs-7 badge badge-light-warning border border-1 border-warning m-1"
}
const _hoisted_13 = {
  key: 1,
  class: "fs-7 badge badge-light-success border border-1 border-success m-1"
}
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, "Requested approvals (" + _toDisplayString(_ctx.totalProvided) + "/" + _toDisplayString(_ctx.totalRequest) + ")", 1),
      _createElementVNode("h3", _hoisted_4, "Active BPs (" + _toDisplayString(_ctx.acceptedTop21.length) + "/21)", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvals, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(index+1), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _hoisted_9,
                        _createVNode(_component_router_link, {
                          to: `/account/${item.actor}`,
                          class: "text-hover-info fs-6 ms-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.actor), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (_ctx.isTop21(item))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Top 21"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item.permission), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (item.status == 'requested')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " pending "))
                        : _createCommentVNode("", true),
                      (item.status == 'provided')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " success "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_Loading, { height: '150px' })
          ]))
    ])
  ]))
}